import { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import Select from "react-select";
import axios from "axios"; // Ensure axios is imported for the API call

export default function RoleAssignmentModal({
  show,
  handleClose,
  row,
  handleRoleChange,
  roleOptions,
}) {
  const [selectedRoles, setSelectedRoles] = useState([]);

  const ApiURL = process.env.REACT_APP_API_URL;

  // Make the API call when the modal is opened
  useEffect(() => {
    if (show) {
      // Fetch the roles for the particular user when modal is shown
      const fetchRoles = async () => {
        try {
          const config = {
            method: "get",
            url: `${ApiURL}/UserRole/Get?userId=${row?.id}`,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace with actual token
            },
          };

          const response = await axios.request(config);
          if (response.data.status && response.data.data) {
            // Map the response roles to the format used by the react-select component
            const fetchedRoles = response.data.data.map((role) => ({
              value: role.type, // assuming 'type' contains the role value
              label: role.type, // assuming 'type' contains the role label
            }));
            setSelectedRoles(fetchedRoles);
          }
        } catch (error) {
          console.error("Error fetching roles:", error);
        }
      };

      fetchRoles();
    }
  }, [show, row?.id]);

  const handleSave = () => {
    handleRoleChange(
      row.id,
      selectedRoles.map((role) => role.value)
    );
    handleClose();
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedRoles(selectedOptions);
  };

  useEffect(() => {
    if (show) {
      // Disable background focus elements when modal is open
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      // Re-enable background focus elements when modal is closed
      document.body.style.overflow = "auto"; // Re-enable scrolling
    }
    return () => {
      document.body.style.overflow = "auto"; // Cleanup in case of unmount
    };
  }, [show]);

  return (
    <>
      <div
        className={`modal fade ${show ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: show ? "block" : "none" }}
        aria-labelledby="roleAssignmentModal"
        aria-hidden={!show}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="roleAssignmentModal">
                Assign Roles
              </h5>
              <button
                type="button"
                className="btn btn-sm btn-transperent btn-danger"
                aria-label="Close"
                onClick={handleClose}
              >
                <FaTimes size={20} />
              </button>
            </div>
            <div className="modal-body">
              <h6>
                Select a role to assign {row?.firstName} {row?.lastName}{" "}
                {row?.surName}:
              </h6>
              <div className="mb-3">
                <Select
                  isMulti
                  options={roleOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={handleSelectChange}
                  value={selectedRoles}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
